import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Row,
  Spin,
  Tabs,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { CSVLink } from "react-csv";
import MineTab from "./MineTab";
import HrTab from "./HrTab";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import AddEditProductLog from "./AddEditProductLog";
import {
  getClientid,
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { useSelector } from "react-redux";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import COLORS from "common/Colors";

dayjs.extend(isoWeek);

const StyledProductWrapper = styled.div`
  .ant-tabs-nav {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    /* padding-right: 20px; */
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    top: 100px !important;
  }
  .ant-modal-header {
    borer: none;
  }
  .ant-modal-body {
    padding: 0px 24px 20px 24px;
  }
  small {
    color: #636980;
  }
`;

const StyledButton = styled(Button)`
  width: 125px;
  color: white;
  background-color: #b7b7b7;
  border-radius: 5px;
  margin-left: 5%;
  @media (max-width: 550px) {
    margin-left: 5px;
    position: relative;
  }
`;

const StyledCol = styled(Col)`
  text-align: right;

  @media (max-width: 550px) {
    text-align: left;
  }
`;

// ✅ Proper formatter for week range
const weekFormat = (value) => {
  if (!value) return "";
  const startOfWeek = value.startOf("isoWeek").format("Do MMM YYYY");
  const endOfWeek = value.endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const exportWeeks = (value) => {
  const startOfWeek = dayjs(value).startOf("isoWeek").format("Do MMM YYYY");
  const endOfWeek = dayjs(value).endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const ProductLog = () => {
  const csvLinkEl = useRef();
  const ClientId = useSelector(getClientid);
  const menuList = useSelector(getMenuList);

  const userRoleId = useSelector(getUserRoleId);
  const Menulist =
    menuList[userRoleId] || Object.values(menuList)[0] || menuList;
  // console.log("Menulist232----->", Menulist.find((item) => item.key === "productlog"));
  console.log("Menulist232----->", Menulist);
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const [weekSelectionForm] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [isHRTab, setIsHRTab] = useState(false);

  const [logDetails, setLogDetails] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [prepareCSVList, setCSVLogList] = useState([]);
  const [logList, setLogList] = useState([]);
  const [data, setData] = useState([]);
  const [isCurrentWeek, setIsCurrentWeek] = useState(false);
  const [checkLog, setIsCheckLog] = useState(false);
  const [isDate, setIsDate] = useState(false);
  const [tabId, setTabId] = useState(
    Menulist?.find(
      (item) => item?.key === "productlog" && item?.permission.view
    )
      ? "1"
      : "2"
  );

  const transformData = (logList, productMap, moduleMap) => {
    return logList.flatMap((log) => {
      const isCurrentWeek =
        dayjs(log?.selected_date).isValid() &&
        dayjs(log?.selected_date).isoWeek() === dayjs().isoWeek() &&
        dayjs(log?.selected_date).isoWeekYear() === dayjs().isoWeekYear();

      const statusLabel =
        log?.status === "submit"
          ? "Submitted"
          : log?.status === "draft"
          ? isCurrentWeek
            ? "Draft"
            : "Not Submitted"
          : isCurrentWeek
          ? "Not Submitted"
          : "-";

      return log.product_log.map((p, idx) => ({
        "User Id": log?.userid,
        Name:
          userList?.find((item) => item?.userid === log?.userid)?.fullname ||
          "-",
        Week: exportWeeks(log.selected_date),
        Project:
          p?.productname ||
          productMap?.find((val) => val?.product_id === p.productId)
            ?.product_name ||
          "-",
        Module:
          p?.modulename ||
          moduleMap?.find((val) => val?.module_id === p.moduleId)
            ?.module_name ||
          "-",
        "Task Id": p?.taskid || "-",
        "Expected Deadline":
          p?.deadline && dayjs(p?.deadline)?.isValid()
            ? dayjs(p?.deadline).format("DD-MM-YYYY HH:mm A")
            : "-",
        "Task Type": p?.tasktype ? p?.tasktype : "-",
        Notes: p.notes,

        Status: statusLabel,

        Mon: parseFloat(p.mon?.toFixed(2)) || 0,
        Tue: parseFloat(p.tue?.toFixed(2)) || 0,
        Wed: parseFloat(p.wed?.toFixed(2)) || 0,
        Thu: parseFloat(p.thu?.toFixed(2)) || 0,
        Fri: parseFloat(p.fri?.toFixed(2)) || 0,
        Sat: parseFloat(p.sat?.toFixed(2)) || 0,
        Sun: parseFloat(p.sun?.toFixed(2)) || 0,
        "Total Hours": p.mon + p.tue + p.wed + p.thu + p.fri + p.sat + p.sun,
      }));
    });
  };

  const prepareCSV = async () => {
    if (logList.length > 0) {
      const data = transformData(logList, projectList, moduleList);

      setCSVLogList(data);

      setTimeout(() => {
        csvLinkEl.current.link.click();
      }, 0);
    } else {
      message.error(`No data available to download.`);
    }
  };

  const getProjectList = async () => {
    const { statusCode, response } = await CALL_API(
      `projectListGet`,
      "get",
      {}
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setProjectList(response);
    }
  };

  const getModuleList = async () => {
    const { statusCode, response } = await CALL_API(`moduleListGet`, "get", {});
    if (statusCode === STATUS_CODE.SUCCESS) {
      setModuleList(response);
    }
  };

  const onChange = (key) => {
    setTabId(key);
    console.log("Tab switched to:", key);
  };

  const items = [
    Menulist?.find(
      (item) => item?.key === "productlog" && item?.permission.view
    ) && {
      key: "1",
      label: "Mine",
      children: (
        <>
          {tabId === "1" && (
            <MineTab
              setIsAddEdit={setIsAddEdit}
              setLogDetails={setLogDetails}
              setLogList={setLogList}
              logList={logList}
              setIsCurrentWeek={setIsCurrentWeek}
              tabId={tabId}
            />
          )}
        </>
      ),
    },
    Menulist?.find(
      (item) => item?.key === "hrproductlog" && item?.permission.view
    ) && {
      key: "2",
      label: "HR",
      children: (
        <>
          {tabId === "2" && (
            <HrTab
              setIsAddEdit={setIsAddEdit}
              setLogDetails={setLogDetails}
              setFilteredList={setLogList}
              filteredList={logList}
              tabId={tabId}
              setIsHRTab={setIsHRTab}
            />
          )}
        </>
      ),
    },
  ];

  const headerstyle = {
    fontSize: "20px",
    fontWeight: "bold",
  };

  const handleFinish = (values) => {
    console.log("Selected Week:", values.selectedweek);
    setIsAddEdit(true);
    setIsHRTab(false);
    // weekSelectionForm?.resetFields();
    setIsDate(false);
    setData([]);
    setOpen(false);
  };

  useEffect(() => {
    getModuleList();
    getProjectList();
  }, []);

  useEffect(() => {
    console.log("form", weekSelectionForm?.getFieldValue("selectedweek"));
  }, [weekSelectionForm?.getFieldValue("selectedweek")]);

  console.log("formvalue-->", weekSelectionForm?.getFieldValue("selectedweek"));

  return (
    <StyledProductWrapper>
      {!isAddEdit && (
        <>
          <Row className="page-title">
            <Col sm={24} md={12} style={headerstyle}>
              Product Log
            </Col>
            <StyledCol sm={24} md={12}>
              <ButtonOutlined
                type="link"
                disabled={logList?.length === 0}
                onClick={prepareCSV}
              >
                Export CSV file
              </ButtonOutlined>
              <CSVLink
                // header={CSVHeaders}
                data={prepareCSVList}
                filename={"LogList.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
              {(Menulist?.find(
                (item) => item?.key === "productlog" && item?.permission.create
              ) ||
                Menulist?.find(
                  (item) =>
                    item?.key === "hrproductlog" && item?.permission.create
                )) && (
                <StyledButton type="primary" onClick={() => setOpen(true)}>
                  +Add Log
                </StyledButton>
              )}
            </StyledCol>
          </Row>

          <div>
            <Tabs defaultActiveKey={tabId} items={items} onChange={onChange} />
          </div>

          <StyledModal
            title="Adding Product Log"
            open={open}
            onCancel={() => {
              setData([]);
              setIsDate(false);
              weekSelectionForm?.resetFields();
              setOpen(false);
            }}
            width={500}
            footer={false}
          >
            <Spin spinning={checkLog}>
              <Form
                form={weekSelectionForm}
                name="week"
                layout="vertical"
                initialValues={{ selectedweek: "" }}
                onFinish={handleFinish}
              >
                <Row>
                  <Col xs={24}>
                    <Form.Item
                      name="selectedweek"
                      label="Select the week you want to log for"
                      rules={[
                        { required: true, message: "Please select a week!" },
                      ]}
                    >
                      {/* <ConfigProvider locale={enGB}> */}
                      <DatePicker
                        className="w-100"
                        picker="date"
                        format={weekFormat}
                        disabledDate={(current) => {
                          return current && current < dayjs().startOf("day");
                        }}
                        onChange={async (date, dateString) => {
                          if (date) {
                            weekSelectionForm?.setFieldValue(
                              "selectedweek",
                              date
                            );
                            setIsCheckLog(true);
                            const weekLabel = `${date.isoWeekYear()}-W${date.isoWeek()}`;
                            const { statusCode, response } = await CALL_API(
                              `productLogGet/${ClientId}`,
                              "post",
                              { week: [weekLabel] }
                            );
                            if (statusCode === STATUS_CODE.SUCCESS) {
                              const filtered = response?.filter(
                                (item) => item?.userid === userInfo?.userid
                              );
                              setData(filtered || []);
                              setIsDate(true); // ✅ store in state
                            }
                          } else {
                            setData([]);
                            setIsDate(false);
                            // reset when cleared
                          }
                          setIsCheckLog(false);
                        }}
                      />

                      {/* </ConfigProvider> */}

                      {data?.length > 0 && (
                        <span style={{ color: "red" }}>Already have a log</span>
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <div className="mt-5 p-0 text-end">
                  <ButtonOutlined
                    onClick={() => {
                      weekSelectionForm?.resetFields();
                      setData([]);
                      setOpen(false);
                      setIsDate("");
                    }}
                  >
                    Cancel
                  </ButtonOutlined>
                  <ButtonFilled
                    className="mx-0"
                    htmlType="submit"
                    // type="submit"
                    disabled={!isDate || data?.length > 0}
                  >
                    Next
                  </ButtonFilled>
                </div>
              </Form>
            </Spin>
          </StyledModal>
        </>
      )}
      {isAddEdit && (
        <AddEditProductLog
          setIsAddEdit={setIsAddEdit}
          setIsHRTab={setIsHRTab}
          selecteddate={
            Object.keys(logDetails)?.length > 0
              ? logDetails?.selected_date
              : weekSelectionForm?.getFieldValue("selectedweek")
          }
          logDetails={logDetails?.product_log?.map((item) => {
            return {
              ...item,
              product: item?.productId,
              moduleId: item?.moduleId,
            };
          })}
          setLogDetails={setLogDetails}
          isEdit={
            (Object.keys(logDetails)?.length > 0 &&
              logDetails?.status !== "draft") ||
            !Menulist?.find(
              (item) => item?.key === "productlog" && item?.permission.edit
            ) ||
            isHRTab
              ? false
              : true
          }
          userid={
            Object.keys(logDetails)?.length > 0
              ? logDetails?.userid
              : userInfo?.userid
          }
          isCurrentWeek={isCurrentWeek}
          tabId={tabId}
          setTabId={setTabId}
          details={logDetails}
        />
      )}
    </StyledProductWrapper>
  );
};

export default ProductLog;
